var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"programme-title"},[_c('p',[_c('span',[_vm._t("default")],2),_c('span',{staticClass:"col-g"},[_vm._t("color")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }